import Close from '@betfan/icons/linear/EssentionalUI/Close.svg?react';
import { Modal } from '@material-ui/core';
import { AuthologicApi } from 'api';
import { DSButton, DSTag } from 'designSystem';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { setDataLayer, setDataLayerWithCallback, ThirdPartyVerificationEvents, VerificationEvents } from 'shared/constants/datalayer';
import { SectionNavigation } from '../../shared/constants/common';
import { FeatureLoader, useMojeIdFeatureFlag } from '../../shared/featureFlags';
import useSectionNavigation from '../../shared/hooks/useSectionNavigation';
import { State } from '../../shared/interface';

const VerificationMethod: React.FC = () => {
	const history = useHistory();
	const { t } = useTranslation();
	const { goToFirstNavigationView } = useSectionNavigation();
	const login = useSelector<State, any>((state) => state.login);

	const mojeIdFeatureFlag = useMojeIdFeatureFlag();

	useEffect(() => {
		// If user doesn't have the PESEL number, redirect them to the verification form immediately.
		if (!login?.accountDetail?.customerData?.personalIdentifier || !mojeIdFeatureFlag.value) {
			openVerificationForm();
		}
	}, [mojeIdFeatureFlag]);

	const handleClose = () => history.goBack();

	const initializeMojeIdVerification = async () => {
		const response = await AuthologicApi.verificationMojeId.initialize();

		setDataLayerWithCallback(ThirdPartyVerificationEvents.VERIFY_THIRD_PARTY_IN(response.data.id, 'mojeID')).finally(() => {
			window.location.href = response.data.url;
		});
	};

	const openVerificationForm = () => {
		goToFirstNavigationView(SectionNavigation.ACCOUNT_VERIFICATION);
		setDataLayer(VerificationEvents.DATALAYER_VERIFICATION_FORM_START);
	};

	return (
		<>
			<Modal
				className="overflow-hiddden flex items-center justify-center backdrop-blur-sm"
				open={true}
				onClose={handleClose}
				BackdropProps={{ className: '!bg-black !bg-opacity-75' }}
			>
				<div className="relative w-full max-w-modal-sm focus:outline-none">
					<div className="p-4 pb-8 rounded-8 bg-white dark:bg-dark-200">
						<div className="flex justify-end">
							<button onClick={handleClose}>
								<Close className="w-6 h-6" />
							</button>
						</div>

						<div className="pt-3">
							<h4 className="text-h3 font-bold tracking-tighter">{t('verificationMethods_bank_title')}</h4>
							<h5 className="text-gray-800 dark:text-gray-200 text-paragraph-sm font-medium mt-2">
								{t('verificationMethods_bank_subtitle')}
							</h5>
							<DSButton size="medium" color="tertiary" className="relative w-full mt-4" onClick={initializeMojeIdVerification}>
								{t('verificationMethods_mojeId')}
								{t('verificationMethods_new') && (
									<DSTag size="medium" color="success" className="absolute right-3 top-1/2 -translate-y-1/2">
										{t('verificationMethods_new')}
									</DSTag>
								)}
							</DSButton>
						</div>

						<div className="mt-8">
							<h4 className="text-h3 font-bold tracking-tighter">{t('verificationMethods_form_title')}</h4>
							<h5 className="text-gray-800 dark:text-gray-200 text-paragraph-sm font-medium mt-2">
								{t('verificationMethods_form_subtitle')}
							</h5>
							<DSButton size="medium" color="tertiary" className="w-full mt-4" onClick={openVerificationForm}>
								{t('verificationMethods_form')}
							</DSButton>
						</div>
					</div>
				</div>
			</Modal>
		</>
	);
};

export const VerificationMethodContainer = () => (
	<FeatureLoader>
		<VerificationMethod />
	</FeatureLoader>
);
